import styled from 'styled-components/macro';

export const ActionsContainer = styled.div`
  align-items: center;
  justify-content: space-between;
  border-bottom: 2px solid #f8f8f8;
  display: flex;
  height: 75px;
  justify-content: space-between;
  padding: 0 1em;
  display: flex;
`;
